import React, { Fragment, useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import classNames from "classnames";
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Intent } from '@blueprintjs/core';

import { AuthenticatedRoute } from 'components/user-access';
import { TopBar, LeftMenu, ShowHide } from 'components/layout';
import { NotificationToaster } from 'components/notifications';
import { AccountService, UserService } from 'services';
import { store } from 'state';
import { LeaveFeedbackModal, ReportIssueModal } from 'pages/feedback';
import { getMainLayoutRoutes } from './mainLayoutRoutes';

export function MainLayout(props) {
    const [loading, setLoading] = useState(true);
    const [onStop, setOnStop] = useState(false);
    const [showLeaveFeedback, setShowLeaveFeedback] = useState(false);
    const [showReportIssue, setShowReportIssue] = useState(false);
    const siteFullWidth = useSelector(state => state.site.fullWidth);
    const location = useLocation();
    const mainLayoutRoutes = getMainLayoutRoutes();
    const userRedirectIndex = mainLayoutRoutes.findIndex((route) => route.path === "/user/create");

    useEffect(function () {
        axios.all([
            AccountService.getMetadata(),
            UserService.getLoggedInUser()
        ]).then(axios.spread((metadata, user) => {
            setLoading(false);
            setOnStop(user.visionOnStop);
        }), () => {
                NotificationToaster.show(Intent.DANGER, "Sorry something has gone wrong. Please try refreshing the page.");
            setLoading(false);
        });
    }, []);

    function renderRoute({ path, action, element }) {
        let pageElement = element;

        if (typeof element === "function") {
            pageElement = element(location);
        }

        let routeElement = pageElement;

        if (action != null) {
            routeElement = <AuthenticatedRoute action={action}>{pageElement}</AuthenticatedRoute>;
        }

        return <Route key={path} path={path} element={routeElement} />;
    }

    return (
        <Fragment>
            <ShowHide
                evaluator={!loading}
                show={(
                    <div>

                        <TopBar environment={window.env.DISPLAY_ENVIRONMENT} onStop={onStop} onLeaveFeedback={() => setShowLeaveFeedback(true)} onReportIssue={() => setShowReportIssue(true)} />
                        <LeftMenu />
                        <div id="main-container" className={classNames({ "full-width": siteFullWidth })}>

                         <Routes>
                                {mainLayoutRoutes.slice(0, userRedirectIndex).map(renderRoute)}
                                {/* Stays inline because its path is read from the store at render time. */}
                                <Route path={"/user/" + store.getState().loggedInUser?.userId} element={<Navigate to="/user/profile" replace />} />
                                {mainLayoutRoutes.slice(userRedirectIndex).map(renderRoute)}
                            </Routes>
                        </div>
                        <LeaveFeedbackModal isOpen={showLeaveFeedback} onClose={() => setShowLeaveFeedback(false)} />
                        <ReportIssueModal isOpen={showReportIssue} onClose={() => setShowReportIssue(false)} />

                    </div>
                )}
            />
        </Fragment>
    );
}
